<template>
	<transition name="modal">
		<div v-if="showMask" class="modal modal-mask">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div id="modaldrag" class="modal-header">
						<slot name="header"></slot>
					</div>
					<div class="modal-body">
						<i v-if="showClose" class="fa-light fa-xmark close" @click.prevent="$emit('close')"></i>
						<slot name="body"></slot>
					</div>
					<div class="modal-footer">
						<slot name="footer">
							<el-button @click.prevent="$emit('close')">
								OK
							</el-button>
						</slot>
					</div>
				</div>
			</div>
		</div>

		<div v-else class="modal-dialog" role="document" style="z-index: 999  !important;" >
			<div class="modal-content">
				<div id="modaldrag" class="modal-header">
					<slot name="header"></slot>
				</div>
				<div class="modal-body">
					<i v-if="showClose" class="fa-light fa-xmark close" @click.prevent="$emit('close')"></i>
					<slot name="body"></slot>
				</div>
				<div class="modal-footer">
					<slot name="footer">
						<el-button  @click.prevent="$emit('close')">
							OK
						</el-button>
					</slot>
				</div>
			</div>
		</div>

	</transition>
</template>
<script>

export default {
    props: {
	    showModal : {
	    	type: Boolean,
		    required: false
		},
	    showMask : {
		    type: Boolean,
		    required: false,
		    default: true
	    },
	    showClose : {
		    type: Boolean,
		    required: false,
		    default: true
	    },
    },
    methods : {
        hideModal () {
           // $emit('close');
        },
        refreshData () {
            this.$emit('refreshData');
        }
    },
}
</script>
<style>
.modal-dialog .modal-content {
	border: 1px solid var(--el-border-color, #E2E8F0);
	border-radius: 12px;
	background-color: #ffffff;
	box-shadow: 0 8px 32px rgba(15, 23, 42, 0.15), 0 2px 8px rgba(15, 23, 42, 0.08);
	overflow: hidden;
}
.modal-mask {
	position: fixed;
	z-index: 1000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(15, 23, 42, 0.45);
	transition: opacity .3s ease;
	display: block
}

div.modal-dialog {
	position: absolute;
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	max-width: 600px;
}
div.modal-header {
	background-color: var(--el-fill-color-light, #F1F5F9);
	border-bottom: 1px solid var(--el-border-color, #E2E8F0);
	cursor: move;
	padding: 12px 44px 12px 18px;
}
div.modal-header h5.modal-title {
	margin: 0;
	font-size: 15px;
	font-weight: 600;
	color: var(--el-text-color-primary, #1E293B);
	letter-spacing: -0.01em;
}
div.modal-body {
	padding: 20px;
	font-size: 13px;
	color: var(--el-text-color-regular, #334155);
}
div.modal-footer {
	padding: 12px 18px;
	border-top: 1px solid var(--el-border-color, #E2E8F0);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
}
div.modal-dialog .close {
	position: absolute;
	top: 14px;
	right: 16px;
	font-size: 16px;
	color: var(--el-text-color-secondary, #64748B);
	cursor: pointer;
}
div.modal-dialog .close:hover { color: var(--el-color-primary, #3F9CA8); }
</style>
